<template>
  <b-modal
    id="info-modal"
    :title="$t('livingImagesViewer.infoModal.title')"
    header-class="justify-content-center"
    title-class="position-absolute text-primary"
    body-class="px-md-4"
    footer-class="py-1"
    scrollable
    centered
    size="md"
  >
    <p class="mt-2 bold-text">{{ $t('livingImagesViewer.infoModal.p1') }}</p>
    <p>{{ $t('livingImagesViewer.infoModal.p2') }}</p>
    <img
      src="@/assets/images/living-images/example-living-image.jpg"
      :alt="$t('livingImagesViewer.infoModal.imageAlt')"
    >
    <i18n
      path="livingImagesViewer.infoModal.imageCaption"
      class="image-caption"
      tag="p"
    >
      <template #link>
        <router-link to="/dashboard/details/act0002156">
          {{ $t('livingImagesViewer.infoModal.imageCaptionLinkValue') }}
        </router-link>
      </template>
    </i18n>
    <hr class="my-4">
    <i18n path="livingImagesViewer.infoModal.reportErrors" tag="p">
      <template #link>
        <router-link :to="{
          name: 'details',
          query: filter,
          params: {
            locale: $route.params.locale,
            listType: $route.params.listType,
            id: '0002156'
          }}"
        >
          {{ $t('livingImagesViewer.infoModal.reportErrorsLinkValue') }}
        </router-link>
      </template>
    </i18n>
    <template #modal-footer>
      <div class="text-right">
        <span id="version"> {{ $t('livingImagesViewer.infoModal.version') }} {{ version }} </span>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'InfoModal',
  props: {
    version: {
      type: String,
      default: '0.1.0'
    },
    filter: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.bold-text {
  font-weight: 500;
}
img {
  max-width: 260px;
  display: block;
  border: 1px solid #ccc;
  margin: 30px auto 20px;
}
.image-caption {
  color: #869094;
  font-size: 0.8em;
  text-align: center;
}
#version {
  color: #a3a3a3;
  font-size: 0.7rem;
}
</style>
